import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import { Link } from '@tanstack/react-router';

const NotFound = () => {
  return (
    <Container maxWidth="md">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '60vh',
          textAlign: 'center',
          py: 4,
        }}
      >
        <Typography variant="h1" component="h1" gutterBottom>
          404
        </Typography>
        <Typography variant="h4" component="h2" gutterBottom>
          Page Not Found
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          The page you're looking for doesn't exist or has been moved.
        </Typography>
        <Box sx={{ mt: 2 }}>
          <Button component={Link} to="/" variant="contained" color="primary" sx={{ mr: 2 }}>
            Go to Home
          </Button>
          <Button component={Link} to="/contact" variant="outlined" color="primary">
            Contact Support
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default NotFound;
